module.exports = __webpack_public_path__ + "static/media/FontAwesome.b06871f2.ttf";